{
  "common": {
    "title": "Charikaty",
    "welcome": "Welcome to Charikaty",
    "login": "Login",
    "signup": "Sign up",
    "logout": "Logout",
    "dashboard": "Dashboard",
    "settings": "Settings",
    "home": "Home",
    "loading": "Loading...",
    "error": "An error occurred",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "workspace": "Workspace",
    "sovereign_os": "Sovereign OS"
  },
  "nav": {
    "home": "Home",
    "platform": "Platform",
    "services": "Services",
    "about": "About",
    "contact": "Contact",
    "start_project": "Start Project",
    "theme_light": "Light Mode",
    "theme_dark": "Dark Mode",
    "language_selector": "Language",
    "lang_fr": "Français",
    "lang_en": "English",
    "lang_ar": "العربية",
    "logo_alt": "Charikaty Logo",
    "hero_backdrop_alt": "Fintech Institutional Backdrop",
    "close_menu_alt": "Close menu",
    "pricing": "Pricing"
  },
  "auth": {
    "login": {
      "title": "Terminal Access",
      "subtitle": "Connect to your sovereign infrastructure.",
      "email": "Email Address",
      "password": "Password",
      "forgot_password": "Forgot password?",
      "submit": "Sign In",
      "no_account": "Don't have an account?",
      "signup_link": "Create an account",
      "error_invalid": "Invalid credentials. Please try again.",
      "error_system": "System error. Please contact support."
    },
    "signup": {
      "title": "New Account",
      "subtitle": "Start your journey towards financial sovereignty.",
      "initialization": "Profile Initialization",
      "step_title": "Step {step} of 2",
      "name": "Full Name",
      "email": "Email Address",
      "password": "Password",
      "next": "Continue",
      "back": "Back",
      "submit": "Create my account",
      "back_to_selection": "Back to profile selection",
      "have_account": "Already have an account?",
      "login_link": "Sign In",
      "error_select_profile": "Please select a profile to continue.",
      "error_password_length": "Password must be at least 8 characters long.",
      "error_institution_email": "Institutions must use an official email address (.dz or .gov).",
      "error_exists": "An account with this email already exists."
    },
    "profiles": {
      "INDIVIDUAL": "Individual",
      "individual_desc": "Individual investors and project owners.",
      "AUTO_ENTREPRENEUR": "Auto-entrepreneur",
      "auto_entrepreneur_desc": "Independents and freelancers.",
      "ENTERPRISE": "Enterprise",
      "enterprise_desc": "Startups, SMEs, and large companies.",
      "INCUBATOR": "Incubator",
      "incubator_desc": "Accelerators and support structures.",
      "INVESTOR": "Investor",
      "investor_desc": "Investment funds and Business Angels.",
      "INSTITUTION": "Institution",
      "institution_desc": "Government agencies and ministries."
    },
    "fields": {
      "full_name": "Full Name",
      "full_name_placeholder": "John Doe",
      "phone": "Phone Number",
      "phone_placeholder": "+213 -- -- -- --",
      "company_name": "Company Name",
      "company_name_placeholder": "Name of your structure",
      "type": "Structure Type",
      "country": "Country of Residence",
      "country_default": "Algeria",
      "incubator_name": "Incubator Name",
      "incubator_name_placeholder": "Name of your accelerator",
      "structure": "Structure Type",
      "investor_name": "Investor / Fund Name",
      "investor_name_placeholder": "Full Name",
      "profile_type": "Profile Type",
      "experience": "Experience Level",
      "institution_name": "Institution Name",
      "institution_name_placeholder": "Ministry / Agency",
      "department": "Department / Division",
      "department_placeholder": "e.g., Innovation Division",
      "role": "Role / Function",
      "role_placeholder": "Director",
      "email_institutional": "Institutional Email",
      "email_professional": "Professional Email",
      "placeholder_email": "name@domain.com",
      "placeholder_password": "••••••••",
      "placeholder_name": "John Doe",
      "password": "Password"
    },
    "options": {
      "startup": "Startup",
      "pme": "SME",
      "project": "Project",
      "public": "Public",
      "private": "Private",
      "individual": "Individual",
      "fund": "Fund / Group",
      "beginner": "Beginner",
      "advanced": "Advanced"
    },
    "demo": {
      "label": "Professional Demo Access",
      "description": "Explore the platform with a pre-configured enterprise profile.",
      "email_label": "Email",
      "password_label": "Password",
      "email": "demo@charikaty.com",
      "button": "Access Demo",
      "account_name": "Demo Account",
      "tooltip": "Demo account for committee"
    },
    "forgot_password": {
      "title": "Access Recovery",
      "subtitle": "Enter your email to receive a reset link.",
      "email_label": "Email Address",
      "email_placeholder": "name@domain.com",
      "submit": "Send reset link",
      "back_to_login": "Back to login",
      "success_title": "Email Sent",
      "success_message": "If an account exists for this email, you will receive a reset link shortly.",
      "error_not_found": "No account found with this email address.",
      "error_system": "An error occurred while sending the email."
    },
    "reset_password": {
      "title": "New Password",
      "subtitle": "Please set your new secure password.",
      "new_password": "New password",
      "confirm_password": "Confirm password",
      "submit": "Reset password",
      "success_title": "Success",
      "success_message": "Your password has been updated successfully.",
      "error_invalid_token": "The reset link is invalid or has expired.",
      "error_mismatch": "Passwords do not match.",
      "error_system": "An error occurred during reset."
    },
    "layout": {
      "visual_title": "The Trusted Infrastructure for the Algerian Economy.",
      "visual_desc": "A single terminal to manage your financial, legal, and strategic assets with sovereign precision.",
      "feature_audit": "Institutional Audit & Compliance",
      "feature_treasury": "Advanced Treasury Management",
      "feature_investor": "Certified Investor Pools",
      "back_to_site": "Back to main site",
      "protocol_label": "Charikaty Protocol • Global Standardized Deployment"
    },
    "admin_demo": {
      "label": "Administrator Demo Access",
      "description": "Reserved for investors, startup committees, and incubator evaluators.",
      "button": "Access Admin Demo",
      "account_name": "Administrator Demo",
      "tooltip": "Demo account for administration",
      "email": "admin@charikaty.dz"
    }
  },
  "kyc": {
    "title": "Identity Verification",
    "nif_label": "Fiscal Identification Number (NIF)",
    "nif_placeholder": "Enter your NIF",
    "nin_label": "National Identification Number (NIN)",
    "nin_placeholder": "Enter your NIN",
    "file_label_auto": "Auto-entrepreneur Card (Scan/Photo)",
    "file_label_id": "National Identity Card (Front/Back)",
    "file_placeholder": "Drag and drop your file here or click to browse",
    "file_error_size": "File is too large (Max 5MB)",
    "file_error_format": "Unsupported format (JPG, PNG, PDF only)",
    "submit": "Verify Identity",
    "skip": "Skip for now"
  },
  "kyc_profile": {
    "title": "Complete your profile",
    "subtitle": "Additional information is required for your profile type."
  },
  "landing": {
    "hero": {
      "badge": "Sovereign Infrastructure",
      "title_main": "Strategic steering for",
      "title_accent": "the modern enterprise.",
      "description": "The integrated platform for finance, legal, and taxation. Manage your entire sovereign structure with institutional precision.",
      "cta_start": "Get Started",
      "cta_explore": "Explore the platform"
    },
    "intro": {
      "label": "Context Analysis",
      "title": "Unified Operations.",
      "subtitle": "Charikaty eliminates silos between your banking, legal, and administrative operations. A single terminal to power your growth securely.",
      "feature_1": {
        "title": "Operational Inertia",
        "desc": "Automated manual processes for increased agility."
      },
      "feature_2": {
        "title": "Tax Precision",
        "desc": "Anticipation and automation of periodic declarations."
      },
      "feature_3": {
        "title": "Institutional Network",
        "desc": "Direct connection to certified investors and partners."
      }
    },
    "pillars": {
      "label": "Growth Ecosystem",
      "title": "Three fundamental pillars.",
      "subtitle": "A modular architecture designed for resilience, security, and institutional performance.",
      "legal": {
        "title": "Digital Legal",
        "desc": "Complete legal lifecycle, from certified creation to status management."
      },
      "finance": {
        "title": "Finance & Taxation",
        "desc": "Predictive visualization and real-time automated tax compliance."
      },
      "invest": {
        "title": "Investment Engine",
        "desc": "Certified investment pools and sovereign fundraising terminal."
      },
      "explore": "Explore"
    },
    "targets": {
      "label": "Target Audiences",
      "title": "A solution for every actor.",
      "subtitle": "The Charikaty protocol dynamically adapts to your institutional profile.",
      "individual": {
        "title": "Individual",
        "desc": "Individual investors and digital project carriers."
      },
      "business": {
        "title": "Business",
        "desc": "Startups, SMEs, and large growing enterprises."
      },
      "incubator": {
        "title": "Incubator",
        "desc": "Public and private support structures."
      },
      "investor": {
        "title": "Investor",
        "desc": "Funds, Business Angels, and intermediary investors."
      },
      "institution": {
        "title": "Institution",
        "desc": "Government agencies and ministries."
      }
    },
    "final_cta": {
      "title": "Take sovereign control of your ecosystem today.",
      "subtitle": "Join the reference infrastructure for modern economic actors.",
      "button": "Create my account"
    },
    "footer": {
      "tagline": "The sovereign ecosystem for intelligent business management.",
      "product": "Product",
      "legal": "Legal",
      "contact": "Contact",
      "privacy": "Privacy",
      "security": "Security",
      "terms": "Terms",
      "support": "Support",
      "audit": "Audit",
      "hq": "HQ Head Office",
      "copyright": "© 2026 // Charikaty Sovereign OS. Designed for growth.",
      "privacy_policy": "Privacy Policy",
      "audit_security": "Audit & Security"
    },
    "city_data": {
      "network_hub": "Network Hub v2.4 // ALGERIA",
      "alger": "Algiers",
      "oran": "Oran",
      "mostaganem": "Mostaganem",
      "tlemcen": "Tlemcen",
      "sidi_bel_abbes": "Sidi Bel Abbes",
      "stats": {
        "population": "Population Hub",
        "startups": "Startup Synergy",
        "funding": "Capital Access",
        "strategic_index": "Strategic Index",
        "rank": "RANK {n}"
      }
    }
  },
  "legal_page": {
    "header": {
      "title": "COMPLIANCE CENTER",
      "subtitle": "Trust & Transparency Layer",
      "version": "v{version}",
      "last_update": "Last update: {date}",
      "full_dossier": "Legal Dossier"
    },
    "sidebar": {
      "nav_label": "Navigation",
      "identity": "Legal Identity",
      "terms": "Terms & Conditions",
      "privacy": "Privacy Policy",
      "data": "Data Usage",
      "rights": "User Rights",
      "downloads": "PDF Documents",
      "contact": "Legal Contact",
      "status_valid": "Validated Compliance",
      "status_desc": "System certified compliant with financial data protection standards (Algeria 2024-2026)."
    },
    "identity": {
      "badge": "Section 01",
      "title": "Platform Identity",
      "subtitle": "Registration information and legal entity operating the system.",
      "company_name_label": "Company Name",
      "company_name": "Charikaty Sovereign OS Technologies Inc.",
      "subsidiary": "Subsidiary of GSD Group (Global Sovereign Digital)",
      "jurisdiction_label": "Jurisdiction",
      "jurisdiction": "Algiers, Algeria"
    },
    "terms": {
      "badge": "Section 02",
      "title": "Terms & Conditions",
      "pdf_button": "T&C (PDF)",
      "items": [
        {
          "title": "Authorized Usage",
          "content": "The use of Charikaty is strictly reserved for business management and institutional financial consulting."
        },
        {
          "title": "Intellectual Property",
          "content": "All AI components (LegalDZ, Genvest) are protected by international and local copyright law."
        },
        {
          "title": "Digital Sovereignty",
          "content": "The user accepts that their data never leaves the sovereign infrastructural perimeter of Algeria."
        },
        {
          "title": "Termination",
          "content": "In case of serious breach of current financial laws, access may be suspended without notice."
        }
      ]
    },
    "privacy": {
      "badge": "Section 03 & 04",
      "title": "Privacy Policy",
      "subtitle": "We apply military standards for the protection of your data. Here is how we process your information.",
      "consent_title": "Consent Management",
      "consent_labels": {
        "analytics": "Analytics & Traffic",
        "marketing": "Marketing & Offers",
        "security": "System Security"
      },
      "rights_title": "Your Rights (Law 18-07)",
      "rights_list": [
        "Right to full access to your data",
        "Right to immediate rectification",
        "Right to be forgotten (after legal audit)",
        "Data portability to certified third parties"
      ],
      "inventory_title": "Data Inventory",
      "table": {
        "headers": {
          "type": "Data Type",
          "purpose": "Purpose",
          "duration": "Duration"
        },
        "rows": [
          {
            "type": "Tax Identity",
            "purpose": "Legal entity verification",
            "duration": "Subscription duration + 10 years"
          },
          {
            "type": "Financial Flows",
            "purpose": "Predictive optimization (Genvest)",
            "duration": "7 years (Tax Obligation)"
          },
          {
            "type": "Connection Logs",
            "purpose": "Security and fraud audit",
            "duration": "24 months"
          }
        ]
      }
    },
    "downloads": {
      "badge": "Section 06",
      "title": "Legal Downloads",
      "subtitle": "Official documents, certificates of compliance and sovereignty attestations.",
      "full_dossier": "Full Legal Dossier",
      "privacy_pdf": "Privacy (PDF)",
      "terms_pdf": "Terms & Conditions"
    },
    "contact": {
      "badge": "Section 07",
      "title": "Legal Department Contact",
      "subtitle": "Any question about compliance? A security flaw report? Use this priority channel.",
      "labels": {
        "full_name": "Full Name",
        "email": "Institutional Email",
        "subject": "Request Subject",
        "message": "Detailed Message"
      },
      "placeholders": {
        "full_name": "Mr. Brahim K. / Legal Firm X",
        "email": "contact@enterprise.dz",
        "subject": "e.g. Data audit request GDPR/Algeria",
        "message": "Describe your request precisely..."
      },
      "secure_label": "Secure transmission (TLS 1.3)",
      "submit": "Send Request",
      "validation": {
        "name_short": "Name is too short (min. 3 characters)",
        "email_invalid": "Please enter a valid email address",
        "subject_short": "Subject is too short (min. 5 characters)",
        "message_short": "Message is too short (min. 20 characters)"
      }
    },
    "toasts": {
      "pdf_success": "Document generated successfully",
      "pdf_desc": "Downloading {type}.pdf in progress...",
      "contact_success": "Request sent to the legal department",
      "contact_desc": "We will get back to you within 48 business hours.",
      "consent_success": "Preference updated",
      "consent_desc": "{key} is now {status}."
    },
    "footer": {
      "copyright": "© 2026 Charikaty Technologies. Operated under Algerian jurisdiction.",
      "status": "System Status",
      "certificates": "Certificate Portal",
      "api_compliance": "API Compliance",
      "tagline": "Sovereign Operating System Infrastructure — Trust Layer"
    }
  },
  "contact_page": {
    "header": {
      "title": "Contact Us",
      "subtitle": "Technical, legal, or financial question? Our experts are at your disposal for tailor-made support."
    },
    "info": {
      "title": "Contact Information",
      "hq": {
        "title": "Headquarters",
        "address": "Business District, Charikaty Tower, Algiers, Algeria"
      },
      "phone": {
        "title": "Phone",
        "hours": "Mon-Thu: 8:30 AM - 5:00 PM"
      },
      "email": {
        "title": "Institutional Email",
        "support": "24/7 Support for Premium accounts"
      }
    },
    "form": {
      "title": "Send a Message",
      "labels": {
        "name": "Full Name",
        "email": "Professional Email",
        "message": "Your Message"
      },
      "placeholders": {
        "name": "e.g. Amina Benali",
        "email": "e.g. a.benali@company.dz",
        "message": "How can we help you?"
      },
      "submit": "Send Message",
      "submitting": "Sending..."
    },
    "toasts": {
      "error_title": "Error",
      "error_desc": "Please enter a subject for your ticket.",
      "success_title": "Ticket Created",
      "success_desc": "Your support request #T-9842 has been recorded. An agent will contact you."
    },
    "categories": {
      "legal": {
        "title": "Legal",
        "desc": "Help with creation and bylaws"
      },
      "finance": {
        "title": "Finance",
        "desc": "Questions on treasury and taxation"
      },
      "invest": {
        "title": "Investment",
        "desc": "Genvest and VC module support"
      }
    },
    "faq": {
      "title": "Knowledge Base",
      "search_placeholder": "Search for an answer...",
      "no_results": "No results for \"{query}\"",
      "items": [
        {
          "category": "legal",
          "question": "How are the generated bylaws certified?",
          "answer": "The bylaws generated by Charikaty use LegalDz AI, trained on the current Algerian commercial code. They are pre-formatted to be accepted by notaries and the CNRC, although a final notarized signature remains mandatory by law."
        },
        {
          "category": "finance",
          "question": "Can I link my business bank account?",
          "answer": "Yes, the platform allows integration via secure banking API to synchronize your cash flows in real time, guaranteeing an exact view of your financial health."
        },
        {
          "category": "account",
          "question": "How do I add collaborators to my space?",
          "answer": "Go to \"Settings\" > \"Team\", then click \"Invite a member\". You will be able to define strict roles (e.g., Read-only, Accountant, Administrator) via our RBAC system."
        },
        {
          "category": "legal",
          "question": "Is the tax simulator accurate?",
          "answer": "The simulator takes into account the IBS/IRG regime, TAP, and CASNOS/CNAS contributions according to the current Finance Law legislation. Rates are updated dynamically."
        }
      ]
    },
    "ticket": {
      "title": "Open a Ticket",
      "subtitle": "Can't find the answer? Contact our technical support.",
      "labels": {
        "category": "Problem Category",
        "subject": "Request Subject",
        "description": "Detailed Description"
      },
      "categories": {
        "bug": "Technical Issue (Bug)",
        "legal": "Legal Assistance / Generation",
        "billing": "Billing and Subscriptions",
        "other": "Other Request"
      },
      "placeholders": {
        "subject": "e.g. Error during name validation",
        "description": "Explain your problem in detail..."
      },
      "submit": "Submit Ticket",
      "submitting": "Creating ticket..."
    }
  },
  "dashboard": {
    "account_menu": {
      "profile": "Profile",
      "aria_label": "Account menu"
    },
    "topbar": {
      "dashboard": "Dashboard",
      "finance": "Finance",
      "genvest": "Genvest",
      "legal": "Legal",
      "operational": "Operational Status",
      "search_placeholder": "Search...",
      "light_mode": "Light Mode",
      "dark_mode": "Dark Mode"
    },
    "nav": {
      "overview": "Overview",
      "infrastructure": "Infrastructure",
      "dashboard": "Dashboard",
      "legal": "Legal",
      "companies": "Companies",
      "finance": "Finance",
      "genvest": "Genvest",
      "menu": "Menu",
      "home": "Home",
      "my_documents": "My Documents",
      "my_companies": "My Companies",
      "my_treasury": "My Treasury",
      "my_assets": "My Assets",
      "settings": "Settings",
      "legal_overview": "Navigation",
      "trademark_validation": "Trademark Validation",
      "ai_assistant": "AI Assistant",
      "legal_simulation": "Legal Simulation",
      "create_company": "Create a Company",
      "legal_events": "Legal Events",
      "documents": "Documents",
      "our_partners": "Our Partners",
      "integrations": "Integrations",
      "compliance": "Compliance",
      "finance_home": "Finance Home",
      "strategic_alerts": "Strategic Alerts",
      "financial_management": "Financial Management",
      "advisor_insight": "Finance Assistant",
      "treasury": "Treasury",
      "project_evaluation": "Project Evaluation",
      "project_financial_study": "Project Financial Study",
      "e_taxes": "E-Taxes",
      "financial_reports": "Financial Reports",
      "performance_indicators": "Performance Indicators",
      "portfolio_simulation": "Portfolio Simulation",
      "creation": "Creation",
      "portfolio": "Portfolio",
      "risks": "Risks",
      "risk_simulation": "Risk Simulation",
      "ai_predictive": "AI Analysis & Prediction",
      "market": "Market",
      "institutional_funding": "Institutional Funding",
      "infra_cockpit": "Infra Cockpit",
      "databases": "Databases",
      "security": "Security",
      "crm_users": "CRM & Users",
      "connectivity": "Connectivity",
      "recovery": "Recovery",
      "logout": "Logout",
      "cockpit": "Cockpit"
    },
    "desc": {
      "dashboard": "Global Cockpit",
      "my_documents": "Resource Center",
      "my_companies": "Legal Entities",
      "my_treasury": "Financial Health",
      "my_assets": "Asset Management",
      "settings": "Account & Preferences",
      "legal_overview": "Global Legal Management",
      "trademark_validation": "Check Name, Brand & Domain",
      "ai_assistant": "Legal Intelligence",
      "legal_simulation": "Feasibility Tests",
      "create_company": "Launch a Structure",
      "legal_events": "Minutes, Meetings & Bylaws",
      "documents": "Vault & Templates",
      "our_partners": "Experts Network",
      "integrations": "API Gateways",
      "compliance": "Monitoring & Obligations",
      "finance_home": "Key Indicators",
      "strategic_alerts": "Points of Attention",
      "financial_management": "Accounts Payable/Receivable",
      "advisor_insight": "Financial Decision Support",
      "treasury": "Real-time Cash Flow",
      "project_evaluation": "ROI & Risks",
      "project_financial_study": "Internal Investments",
      "e_taxes": "Tax Declarations",
      "financial_reports": "Archives & Exports",
      "performance_indicators": "In-depth Analysis",
      "institutional_partners": "Institutional Experts",
      "portfolio_simulation": "Build a Strategy",
      "creation_portfolio": "Create your Portfolio",
      "portfolio_follow": "Monitoring and Management",
      "exposure_analysis": "Exposure Analysis",
      "risk_scenarios": "Risk Scenarios",
      "strategic_analytics": "Strategic Analyses",
      "live_stream": "Live Stream",
      "sovereign_pipeline": "Sovereign Pipeline",
      "strategic_partners": "Strategic Partners",
      "infra_core": "Platform Core",
      "distributed_systems": "Distributed Systems",
      "cybersecurity": "Cybersecurity",
      "customer_engine": "Customer Engine",
      "load_balancing": "Load Balancing",
      "backup_plan": "Backup & Recovery Plan"
    },
    "sections": {
      "main_management": "MAIN MANAGEMENT",
      "intelligence_compliance": "INTELLIGENCE & COMPLIANCE",
      "partners_ecosystem": "PARTNERS & ECOSYSTEM",
      "financial_operations": "FINANCIAL OPERATIONS",
      "strategic_intelligence": "STRATEGIC INTELLIGENCE",
      "analysis_projects": "ANALYSIS & PROJECTS",
      "ecosystem": "ECOSYSTEM",
      "operations_assets": "OPERATIONS & ASSETS",
      "analysis_simulation": "ANALYSIS & SIMULATION",
      "market_ecosystem": "MARKET & ECOSYSTEM",
      "navigation": "Navigation"
    },
    "overview": {
      "title": "Dashboard",
      "subtitle": "Overview of your Charikaty ecosystem",
      "access_module": "ACCESS MODULE",
      "legal_desc": "Entity management, compliance and legal simulators.",
      "finance_desc": "Financial management, reports and performance indicators.",
      "genvest_desc": "Investments, portfolio analysis and opportunities.",
      "infra_desc": "System monitoring, security and connectivity.",
      "settings_desc": "Account configuration, preferences and security."
    },
    "legal_page": {
      "title": "Companies & Legal",
      "description": "Secure gateway to governance and legal corporate management modules.",
      "badge": "GOVERNANCE",
      "modules": {
        "nav": {
          "title": "Navigation",
          "desc": "Legal module overview and steering"
        },
        "brand": {
          "title": "Trademark Validation",
          "desc": "Check availability and brand protection"
        },
        "ai": {
          "title": "AI Assistant",
          "desc": "Intelligent AI-based legal advisor"
        },
        "sim": {
          "title": "Legal Simulation",
          "desc": "Structure and legal impact simulator"
        },
        "create": {
          "title": "Create a Company",
          "desc": "Launch and formation of new entities"
        },
        "events": {
          "title": "Legal Events",
          "desc": "Meetings, mutations and acts management"
        },
        "docs": {
          "title": "Documents",
          "desc": "Vault and official documents generation"
        },
        "partners": {
          "title": "Our Partners",
          "desc": "Strategic network of experts and partners"
        },
        "integrations": {
          "title": "Integrations",
          "desc": "Connection with external systems and APIs"
        },
        "compliance": {
          "title": "Compliance",
          "desc": "Regulatory monitoring and compliance audits"
        }
      }
    },
    "finance_page": {
      "title": "Finance Console",
      "description": "Performance steering, tax compliance and strategic decision support for your company.",
      "badge": "LIVE",
      "modules": {
        "acc": {
          "title": "Accounting Hub",
          "desc": "Management of accounting and financial flows"
        },
        "advisor": {
          "title": "Charikaty Advisor",
          "desc": "Artificial intelligence for decision support"
        },
        "cash": {
          "title": "Cash Management",
          "desc": "Tracking liquidity and cash-flow forecasts"
        },
        "eval": {
          "title": "Project Evaluation",
          "desc": "Profitability analysis and investment simulation"
        },
        "projects": {
          "title": "Investment Projects",
          "desc": "Operational tracking of ongoing projects"
        },
        "taxes": {
          "title": "E-Taxes & Fiscality",
          "desc": "Tax returns and G50 compliance"
        },
        "reports": {
          "title": "Financial Reports",
          "desc": "Balance sheets, income statements and financials"
        },
        "indicators": {
          "title": "Indicators & Data",
          "desc": "Visualization of KPIs and performance metrics"
        },
        "alerts": {
          "title": "Strategic Alerts",
          "desc": "Management of financial alerts and notifications"
        },
        "partners": {
          "title": "Financial Partners",
          "desc": "Banking and institutional ecosystem"
        }
      }
    },
    "genvest_page": {
      "title": "GenVest Command",
      "description": "Strategic steering console for assets and predictive market simulations.",
      "badge": "SYSTEM ACTIVE",
      "modules": {
        "portfolio": {
          "title": "Active Portfolio",
          "desc": "Position management and real-time performance tracking"
        },
        "ai": {
          "title": "Predictive AI",
          "desc": "Investment signals and quantitative predictive analysis"
        },
        "opportunities": {
          "title": "Market Opportunities",
          "desc": "Strategic intelligence and growth opportunity detection"
        },
        "risks": {
          "title": "Risk Analysis",
          "desc": "Exposure monitoring and regulatory compliance"
        },
        "sim_port": {
          "title": "Portfolio Simulation",
          "desc": "Asset allocation simulator and yield projection"
        },
        "sim_risk": {
          "title": "Risk Simulation",
          "desc": "Stress-tests and critical scenario impact simulation"
        },
        "deal": {
          "title": "Institutional Deal Flow",
          "desc": "Access to institutional financing and fundraising"
        },
        "creation": {
          "title": "Portfolio Creation",
          "desc": "Creation workflow and constitution of new funds"
        },
        "integrations": {
          "title": "Integrations & API",
          "desc": "Connection to data flows and external systems"
        },
        "alerts": {
          "title": "Strategic Alerts",
          "desc": "Monitoring system and critical risk notifications"
        }
      }
    },
    "settings_page": {
      "title": "Settings & Security",
      "description": "Manage your company information, access, and security preferences for your account.",
      "legal": {
        "title": "Legal Framework & Governance",
        "subtitle": "Algerian Commercial Law",
        "regime_label": "Regulatory Regime",
        "rc_option": "COMMERCIAL LAW (RC)",
        "zes_option": "SPECIAL ECONOMIC ZONE (ZES)",
        "sig_label": "Digital Signature",
        "sig_status": "ANC Certificate Active",
        "save_btn": "Save Settings"
      },
      "services": {
        "title": "Services & Automations",
        "subtitle": "Active management modules",
        "mod1": {
          "name": "Tracfin Monitoring",
          "desc": "Automatic transaction vigilance"
        },
        "mod2": {
          "name": "G50 Tax Calculation",
          "desc": "Automatic tax provisioning"
        },
        "mod3": {
          "name": "RC Sync",
          "desc": "Direct link with the Trade Register"
        },
        "mod4": {
          "name": "AI Audit",
          "desc": "Intelligent anomaly detection"
        },
        "active": "ACTIVE",
        "inactive": "DISABLED"
      },
      "system": {
        "title": "System Status",
        "node1": "Main Server",
        "node2": "DGI Gateway",
        "node3": "Calculation Engine",
        "status_optimal": "Optimal",
        "status_connected": "Connected",
        "status_stable": "Stable",
        "api_btn": "Generate API Keys"
      },
      "security": {
        "title": "Security",
        "desc": "Your account uses bank-grade encryption. Avoid sharing your access.",
        "status": "Encryption Active"
      },
      "support": {
        "label": "Need help?",
        "desc": "Our technicians are available to assist you with the configuration.",
        "btn": "Contact support"
      }
    },
    "ai_legal_page": {
      "title": "Legal DZ AI",
      "description": "AI-powered sovereign legal assistant",
      "system": "DZ-LEGAL-CORE",
      "infrastructure": "INFRASTRUCTURE",
      "active": "ACTIVE",
      "mission_vision": "MISSION & VISION",
      "mission_headline_1": "ANALYSIS",
      "mission_headline_2": "LEGAL",
      "mission_headline_3": "SOVEREIGN",
      "mission_text": "Legal DZ AI is designed to address the specificities of local commercial law, ensuring total compliance.",
      "garanties": "SYSTEM GUARANTEES",
      "garanties_list": {
        "g1": "Locally hosted data",
        "g2": "CNPD Compliance",
        "g3": "Daily updates"
      },
      "button": "ACCESS THE PLATFORM",
      "redirection": "REDIRECTION TO DZ-LEGAL-AI.COM",
      "capabilities": {
        "c1": {
          "title": "Immediate Analysis",
          "status": "ACTIVE",
          "desc": "Instant processing of complex legal documents."
        },
        "c2": {
          "title": "Assisted Drafting",
          "status": "OPERATIONAL",
          "desc": "Generation of contracts and deeds."
        },
        "c3": {
          "title": "Regulatory Watch",
          "status": "SYNC",
          "desc": "Real-time tracking of the Algerian Official Journal."
        },
        "c4": {
          "title": "Smart Search",
          "status": "ONLINE",
          "desc": "Access to a database of jurisprudence."
        }
      },
      "metrics_title": "SYSTEM PERFORMANCE",
      "version": "VERSION V2.4",
      "metrics": {
        "m1": {
          "label": "ACCURACY",
          "value": "99.8%",
          "sub": "SUCCESS RATE"
        },
        "m2": {
          "label": "LATENCY",
          "value": "120ms",
          "sub": "RESPONSE TIME"
        },
        "m3": {
          "label": "TOKENS",
          "value": "1.2M",
          "sub": "/ SECOND"
        }
      },
      "integration_title": "DEEP INTEGRATION",
      "integration_depth": "ANALYSIS DEPTH",
      "integration_sync": "FULL SYNC",
      "integration_text": "The AI engine is directly coupled to your company's database for maximum contextual relevance.",
      "next_step_title": "NEXT STEP",
      "next_step_desc": "Planned integration of litigation modules in Q3."
    }
  },
  "statutes_generator": {
    "title": "Statutes Generator",
    "subtitle": "Create your customized articles of association compliant with Algerian commercial law",
    "actions": {
      "reset": "Reset",
      "generate": "Generate Statutes",
      "preview": "Preview",
      "download": "Download PDF"
    },
    "sections": {
      "company_info": "Company Information",
      "legal_form": "Legal Form",
      "capital": "Share Capital",
      "partners": "Partners & Shareholders",
      "governance": "Governance & Management"
    },
    "fields": {
      "name": "Company Name",
      "name_placeholder": "Enter company name",
      "activity": "Activity (Object)",
      "activity_placeholder": "Describe the main activity",
      "duration": "Duration (Years)",
      "head_office": "Head Office Address",
      "head_office_placeholder": "Full address in Algeria",
      "form_label": "Select Legal Form",
      "capital_amount": "Total Capital (DZD)",
      "share_value": "Nominal Value per Share",
      "total_shares": "Total Number of Shares"
    },
    "forms": {
      "sarl": "SARL (Limited Liability Company)",
      "eurl": "EURL (Single Member Company)",
      "spa": "SPA (Joint Stock Company)",
      "snc": "SNC (General Partnership)"
    },
    "validation": {
      "incomplete": "Please complete all required fields",
      "invalid_capital": "Capital must be at least 100,000 DZD for SARL",
      "no_partners": "At least one partner is required"
    }
  },
  "brand_val": {
    "report_title": "BRAND AUDIT REPORT",
    "official_document": "Official Simulation Document",
    "government_header": "DEMOCRATIC AND POPULAR REPUBLIC OF ALGERIA",
    "ministry_header": "MINISTRY OF COMMERCE AND EXPORT PROMOTION",
    "cnrc_header": "NATIONAL CENTER OF THE COMMERCIAL REGISTER",
    "id": "Simulation ID",
    "date": "Generation Date",
    "executive_summary": "EXECUTIVE SUMMARY",
    "status": "LEGAL STATUS",
    "explanation": "EXPERT REASONING",
    "details": "TECHNICAL DETAILS",
    "similarity_analysis": "SIMILARITY ANALYSIS",
    "registry_results": "REGISTRY RESULTS",
    "name_col": "Name",
    "sector_col": "Sector",
    "desc_col": "Description",
    "score_col": "Score",
    "risk_col": "Risk",
    "export_pdf": "EXPORT PDF",
    "export_excel": "EXPORT EXCEL",
    "new_search": "NEW SEARCH",
    "brand_name": "Brand Name",
    "sector": "Economic Sector",
    "decision": "Strategic Decision",
    "recommendations": "Recommendations",
    "risk_none": "None",
    "risk_low": "Low",
    "risk_medium": "Moderate",
    "risk_high": "High",
    "risk_critical": "Critical"
  },
  "name_check": {
    "title": "Name Verification",
    "subtitle": "Instant Legal Audit & Strategic Validation",
    "connected_to": "Connected to",
    "central_registry": "Central Registry",
    "brand_arbitrage": "Brand Arbitrage",
    "description": "Our legal intelligence engine analyzes your brand against institutional databases and phonetic similarity patterns.",
    "multi_layer_audit": "Multi-Layer Audit",
    "check_1": "CNRC Prior Art Verification",
    "check_2": "Phonetic Similarity (Match Engine)",
    "check_3": "Sectoral Risk Analysis",
    "check_4": "Domain Availability (.dz, .com)",
    "step1_label": "1. Brand Name",
    "name_placeholder": "EX: TECH DZ SOLUTIONS",
    "step2_label": "2. Economic Sector",
    "step3_label": "3. Additional Information",
    "details_placeholder": "Specify the exact nature of the products or services...",
    "analyzing": "ANALYSIS IN PROGRESS...",
    "analyze_button": "ANALYZE BRAND",
    "database_info": "CNRC-2026 Database",
    "compliance_guarantee": "Legal Compliance Guaranteed",
    "analyzing_title": "Generating Audit Report",
    "analyzing_subtitle": "Analyzing CNRC & INAPI registries in progress...",
    "sectors": {
      "tech": "Technology & Digital",
      "finance": "Finance & Fintech",
      "industry": "Industry & Manufacturing",
      "construction": "Construction & Infrastructure",
      "services": "Professional Services",
      "health": "Health & Pharma",
      "trade": "Trade & Distribution",
      "agro": "Agro-Food",
      "telecom": "Telecommunications",
      "other": "Other Sectors"
    },
    "errors": {
      "reserved": "This name is already reserved in your current session."
    },
    "engine": {
      "status": {
        "unavailable": "NOT AVAILABLE",
        "risky": "RISKY",
        "available": "AVAILABLE"
      },
      "explanation": {
        "unavailable": "Name already registered or too similar to an existing entity.",
        "risky": "Partially similar name. Risk of confusion or rejection by CNRC.",
        "available": "Compliant name available for use."
      }
    }
  },
  "name_result": {
    "title": "Report: {{name}}",
    "audit_ref": "Official Legal Audit • REF: {{id}}",
    "archived": "ARCHIVED",
    "badge": "BRAND AUDIT",
    "archived_btn": "In the vault",
    "archive_btn": "Archive",
    "share_btn": "Share",
    "availability_label": "Availability",
    "status": {
      "valid": "VALIDATED",
      "risky": "AT RISK",
      "critical": "CRITICAL"
    },
    "main_title_available": "The name is ready for registration.",
    "main_title_risky": "Priority risk detected in the sector.",
    "ministry_stamp_1": "Ministry of",
    "ministry_stamp_2": "Industry",
    "approved": "APPROVED",
    "confidence_score": "Audit Confidence",
    "risk_level": "Risk Level",
    "ip_protection": "IP Protection",
    "ip_protection_status": "OPTIMAL",
    "comparative_analysis": "Comparative Analysis",
    "registry_label": "Algerian National Registries (CNRC)",
    "conflict_phonetic": "Phonetic and sectoral conflict detected",
    "similarity": "SIMILARITY",
    "no_conflict_title": "No major conflicts detected",
    "no_conflict_desc": "The name is free of critical prior art in the {{sector}} sector.",
    "system_decision": "System Decision",
    "legal_arbitrage": "Legal Intelligence Arbitration",
    "recommended_action": "Recommended Action:",
    "action_accept": "You can proceed with the name reservation and the formation of the file.",
    "action_modify": "We advise adding a distinctive qualifier to avoid any CNRC rejection.",
    "action_reject": "This name is too close to a well-known brand. A rejection is almost certain.",
    "reserve_btn": "Reserve Name",
    "launch_creation_btn": "Launch Creation",
    "modify_project_btn": "Modify Project",
    "digital_assets": "Available Digital Assets",
    "domain_available": "Available",
    "domain_taken": "Taken",
    "validity_title": "Audit Validity",
    "validity_desc": "72 Hours (Real-time CNRC Data)",
    "authenticity_title": "Verify authenticity",
    "authenticity_desc": "Scan to verify the originality of the certificate on the GSD portal.",
    "modal_title": "Name reserved successfully",
    "modal_desc": "Your choice is saved in your session. You can now launch the administrative creation of your company.",
    "modal_create_btn": "Create my company now",
    "modal_close_btn": "Close",
    "modal_validity": "Reservation valid 24h",
    "modal_approved": "Decision Approved",
    "footer_advisory": "Warning: This report is an institutional decision support tool. It does not replace the advice of a licensed legal counsel.",
    "metrics": {
      "memorability": "Memorability",
      "protection": "Legal Protection",
      "availability": "Availability",
      "memorability_desc": "Evaluates how easily your name can be remembered by customers.",
      "protection_desc": "Calculates the legal strength of the brand against competitors.",
      "availability_desc": "Checks real-time availability in official registries."
    }
  },
  "export": {
    "pdf_header1": "PEOPLE'S DEMOCRATIC REPUBLIC OF ALGERIA",
    "pdf_header2": "MINISTRY OF INDUSTRY AND COMMERCE - CHARIKATY GSD",
    "pdf_title": "NAME AUDIT CERTIFICATE",
    "pdf_ref": "REFERENCE",
    "pdf_details": "PROJECT DETAILS",
    "pdf_name": "Name",
    "pdf_sector": "Activity Sector",
    "pdf_date": "Audit Date",
    "pdf_decision": "DECISION",
    "pdf_favorable": "FAVORABLE",
    "pdf_unfavorable": "UNFAVORABLE",
    "pdf_modification": "MODIFICATION RECOMMENDATION",
    "pdf_analysis_title": "PRIORITY ANALYSIS (CNRC / INAPI)",
    "pdf_table_name": "Conflicting Name",
    "pdf_table_sector": "Sector",
    "pdf_table_similarity": "Similarity",
    "pdf_table_no_conflict": "No major conflict detected",
    "pdf_footer1": "This document is electronically generated and has informative value for the creation of the CNRC file.",
    "pdf_footer2": "Any reproduction must retain the original watermarks.",
    "toast_pdf_success": "Institutional PDF report generated successfully",
    "toast_excel_success": "Structured Excel audit exported",
    "toast_share_success": "Audit link copied to clipboard",
    "toast_share_desc": "You can now share it safely.",
    "toast_archive_loading": "Secure archiving in the institutional vault...",
    "toast_archive_success": "Report successfully archived in your secure space",
    "toast_archive_error": "Error during archiving",
    "excel_summary_sheet": "Audit Summary",
    "excel_conflicts_sheet": "Detailed Conflicts",
    "excel_gov_sheet": "Governance & Advice",
    "excel_gov_title": "GOVERNANCE AND COMPLIANCE ADVICE",
    "excel_gov_tip1_title": "1. TRADEMARK PROTECTION",
    "excel_gov_tip1_desc": "It is strongly recommended to register your trademark with INAPI as soon as you obtain the trade register.",
    "excel_gov_tip2_title": "2. .DZ DOMAIN",
    "excel_gov_tip2_desc": "Priority should be given to registering the .dz domain name to establish your national digital identity.",
    "excel_gov_tip3_title": "3. CORPORATE ACTS",
    "excel_gov_tip3_desc": "Ensure that the name is identical in all your acts (bylaws, minutes, invoices).",
    "excel_audit_id": "AUDIT ID",
    "excel_system_label": "SYSTEM",
    "excel_system_val": "CHARIKATY GSD v4.0 - MINISTRY OF INDUSTRY",
    "excel_explication": "EXPLANATION"
  },
  "integrations_page": {
    "title": "Integrated Partners",
    "description": "Platforms connected to your entrepreneurial environment. Access essential services securely.",
    "partners": {
      "etaxes": {
        "name": "E-Taxes",
        "desc": "Tax management platform for filing and tracking tax obligations."
      },
      "guichet": {
        "name": "One-Stop Shop",
        "desc": "Centralized system for the creation and administrative management of companies."
      },
      "moustachir": {
        "name": "Moustachir Idarati",
        "desc": "Administrative support and consulting platform for entrepreneurs."
      },
      "cnrc": {
        "name": "CNRC (Sidjilcom)",
        "desc": "Commercial register for verification and registration of companies."
      },
      "sarfipay": {
        "name": "SarfiPay",
        "desc": "Integrated electronic payment solution for financial transactions and services."
      }
    },
    "status": {
      "operational": "Operational",
      "connected": "Connected",
      "certified": "Certified",
      "active": "Active",
      "coming_soon": "Integration in progress"
    },
    "access_btn": "Access",
    "redirecting": "Redirecting to {{name}}...",
    "external_link_notice": "You are being redirected to a secure external platform.",
    "ecosystem": {
      "title": "Total Connectivity",
      "desc": "Charikaty federates the best digital services to simplify your growth journey."
    },
    "error": {
      "title": "Critical System Error",
      "description": "The module could not be loaded correctly. Technical detail:",
      "reset": "Reset Module"
    },
    "options": {
      "yes": "YES",
      "no": "NO"
    },
    "popup": {
      "title": "Coming Soon",
      "desc": "This integration is currently being developed by our technical teams.",
      "btn": "Understood"
    }
  },
  "genvest": {
    "portfolio": {
      "title": "Portfolio Terminal",
      "subtitle": "Institutional asset management and real-time performance analysis.",
      "real_mode": "Real Mode",
      "simulation_mode": "Simulation",
      "simulation": "Simulation",
      "sync_complete": "Sync Complete",
      "sync_success": "Market data synchronized successfully",
      "sync_in_progress": "Synchronizing market data...",
      "new_position": "New Position",
      "tabs": {
        "overview": "Overview",
        "analysis": "Advanced Analysis",
        "actions": "Execution & Flows",
        "ceo_view": "CEO View",
        "analyst_view": "Analyst View",
        "execution_view": "Execution View"
      },
      "executive_dashboard": "Executive Dashboard",
      "historical_performance": "Historical Performance",
      "portfolio_label": "Portfolio",
      "benchmark_label": "Algerian Benchmark",
      "strategic_allocation": "Strategic Allocation",
      "risk_analysis": "Algorithmic Risk Analysis",
      "diversification_score": "Diversification Score",
      "diversification_comment": "Your portfolio shows strong diversification in strategic Algerian sectors.",
      "metrics": {
        "volatility": "Volatility (Ex-post)",
        "volatility_desc": "Annual historical risk",
        "sharpe": "Sharpe Ratio",
        "sharpe_desc": "Return / Risk",
        "var": "Value at Risk (95%)",
        "var_desc": "Max loss (1 day)",
        "cvar": "Conditional VaR (95%)",
        "cvar_desc": "Expected shortfall",
        "return": "Expected Return",
        "return_desc": "12-month projection",
        "drawdown": "Max Drawdown",
        "drawdown_desc": "Max historical decline"
      },
      "performance": {
        "title": "Relative Performance",
        "simulated_projection": "SIMULATED PROJECTION",
        "vs_benchmark": "vs BENCHMARK",
        "subtitle_simulated": "Predictive modeling based on investor profile",
        "subtitle_real": "Dynamic Net Asset Value (NAV) comparison",
        "simulated_data": "Simulated Data",
        "portfolio": "Portfolio",
        "benchmark": "Benchmark (DZD Index)",
        "alpha_label": "Outperformance",
        "legend_portfolio": "Alpha Portfolio",
        "legend_benchmark": "DZD Market Index"
      },
      "allocation": {
        "by_type": "Allocation by Type",
        "by_type_desc": "Weight of asset classes in total portfolio",
        "by_sector": "Sector Exposure",
        "by_sector_desc": "Capital concentration by sector"
      },
      "insights": {
        "ai_title": "Genvest AI Insights",
        "default_category": "Portfolio Analysis",
        "estimated_impact": "Estimated Impact",
        "rebalance_suggested": "Rebalance Suggested",
        "rebalance_desc": "Your portfolio has drifted from its target. AI suggests {{count}} adjustments to optimize risk/return.",
        "apply_rebalance": "Apply Rebalance"
      },
      "stats": {
        "total_value": "Total Value",
        "simulated": "Simulated",
        "performance_ytd": "Performance YTD",
        "assets_held": "Assets Held",
        "cash_excluded": "Excl. cash",
        "asset_alloc": "Asset Allocation",
        "risk_score": "Risk Score",
        "risk_level": "Level {{level}}",
        "diversification": "Diversification",
        "hhi_score": "Optimized HHI Score",
        "portfolio_health": "Portfolio Health",
        "health_excellent": "Excellent",
        "health_optimal": "Optimal",
        "health_low": "Low",
        "sharpe_ratio": "Sharpe Ratio",
        "optimal": "Optimal",
        "max_drawdown": "Max Drawdown",
        "available_cash": "Available Cash",
        "deposit": "Deposit",
        "levels": {
          "LOW": "Low",
          "MODERATE": "Moderate",
          "HIGH": "High",
          "EXTREME": "Extreme"
        }
      },
      "inventory": {
        "title": "Asset Inventory",
        "subtitle": "Complete details of your current positions",
        "search_placeholder": "Search an asset...",
        "add_button": "Add",
        "table": {
          "asset": "Asset / Symbol",
          "type": "Type / Sector",
          "qty": "Quantity",
          "price": "PAMP / Current",
          "total": "Total Value",
          "performance": "Performance",
          "signal": "AI Signal",
          "actions": "Actions",
          "pamp_label": "PAMP: ",
          "hold": "Hold",
          "buy": "Buy",
          "sell": "Sell",
          "analyzing": "Analyzing...",
          "edit_tooltip": "Edit position",
          "remove_tooltip": "Close position"
        },
        "empty": {
          "title": "No assets in institutional registry.",
          "action": "Import first asset"
        }
      },
      "asset_types": {
        "EQUITY": "Equities",
        "EQUITY_desc": "Company equity securities",
        "BOND": "Bonds",
        "BOND_desc": "Debt securities (State or Corporate)",
        "REAL_ASSET": "Real Assets",
        "REAL_ASSET_desc": "Real Estate, Agriculture, Industry",
        "STARTUP_SHARE": "Startups",
        "STARTUP_SHARE_desc": "Venture capital and direct participations"
      },
      "sectors": {
        "Technology": "Technology",
        "Finance": "Finance",
        "Energy": "Energy",
        "Healthcare": "Healthcare",
        "Consumer": "Consumer",
        "Real Estate": "Real Estate",
        "Government": "Government",
        "Agriculture": "Agriculture",
        "Industrie": "Industry",
        "Communication": "Communication",
        "Etat": "State",
        "Immobilier": "Real Estate",
        "Technologie": "Technology",
        "Gouvernement": "Government",
        "Autre": "Other"
      },
      "modals": {
        "asset": {
          "title_add": "New Investment",
          "title_edit": "Asset Management",
          "subtitle": "Institutional asset parameter configuration",
          "name_label": "Asset Name",
          "name_placeholder": "e.g., Al-Djazair Growth",
          "symbol_label": "Ticker / Symbol",
          "symbol_placeholder": "e.g., DZG-2026",
          "type_label": "Asset Type",
          "sector_label": "Strategic Sector",
          "financial_data": "Transactional Data",
          "qty_label": "quantity",
          "avg_price_label": "pamp price (buy)",
          "current_price_label": "current price",
          "volatility_label": "Expected Volatility",
          "inflation_label": "Inflation Protection",
          "submit_add": "Confirm Investment",
          "submit_edit": "Save Changes"
        }
      },
      "stress_testing": {
        "title": "Crisis Simulations (Stress Test)",
        "subtitle": "Analysis of resilience against major macroeconomic shocks.",
        "scenarios": {
          "RATES_HIKE": {
            "title": "Rates Hike (+200 bps)",
            "type": "Macro Scenario"
          },
          "INFLATION_SPIKE": {
            "title": "Inflation Shock (15%)",
            "type": "Macro Scenario"
          },
          "MARKET_CRASH": {
            "title": "Market Crash (-35%)",
            "type": "Macro Scenario"
          },
          "descriptions": {
            "RATES_HIKE": "+200 bps hike: Severe correction on long-term assets (bonds, real estate) and compression of tech valuation multiples.",
            "INFLATION_SPIKE": "Inflation Shock (15%): Massive erosion of cash and nominal bonds. Partial protection via real estate and real assets.",
            "MARKET_CRASH": "Systemic Market Crash (-35%): Collapse of risky assets. Only sovereign bonds offer protective negative correlation.",
            "empty": "No estimated impact (Empty Portfolio)"
          }
        },
        "results": {
          "impact_estimated": "Estimated Impact",
          "severity": "Severity",
          "critical": "CRITICAL",
          "moderate": "MODERATE",
          "hedging_btn": "Hedging Simulation"
        },
        "empty_state": "Select a scenario to launch crisis simulation"
      },
      "audit": {
        "title": "Compliance Audit",
        "subtitle": "Genvest AI Institutional Report",
        "demo_warning": "Warning: Report based on simulation data (Demo Mode)",
        "global_status": "Global Status",
        "integrity_status": "INTEGRAL",
        "last_check": "Last Verification",
        "analysis_title": "Checkpoint Analysis",
        "download_btn": "Download Certified PDF",
        "validate_btn": "Validate Report",
        "footer_certification": "Certification compliant with Regulatory Authority standards (COSO compliant)",
        "checks": {
          "allocation": {
            "title": "Regulatory Allocation Limits",
            "desc": "No asset class exceeds the prudential thresholds set by the strategy."
          },
          "esg": {
            "title": "ESG & Ethics Compliance",
            "desc": "Average portfolio score: 84/100. Strong alignment with sustainable finance criteria."
          },
          "concentration": {
            "title": "Sectoral Concentration Alert",
            "desc": "Maximum sectoral exposure is {{percentage}}%."
          },
          "liquidity": {
            "title": "Liquidity Coverage Ratio",
            "desc": "Your liquidities represent {{percentage}}% of the total."
          }
        },
        "status": {
          "compliant": "COMPLIANT",
          "optimal": "OPTIMAL",
          "warning": "WARNING",
          "critical": "CRITICAL"
        }
      },
      "transactions": {
        "title": "Transaction History",
        "subtitle": "Complete archives of your capital movements",
        "empty": "No transactions recorded.",
        "table": {
          "date": "Date",
          "action": "Action",
          "asset": "Asset / Label",
          "qty": "Quantity",
          "price": "Unit Price",
          "total": "Total",
          "status": "Status"
        },
        "status": {
          "completed": "COMPLETED",
          "pending": "PENDING",
          "cancelled": "CANCELLED"
        },
        "types": {
          "buy": "BUY",
          "sell": "SELL",
          "dividend": "DIVIDEND",
          "fee": "FEE",
          "deposit": "DEPOSIT",
          "withdraw": "WITHDRAW"
        }
      }
    }
  },
  "finance": {
    "etaxes": {
      "portal_title": "E-Taxes Portal",
      "unified_interface": "Unified Interface",
      "partnership_prefix": "Official DGI direct integration through ",
      "direct_link": "Direct Connection",
      "nodes_dgi": "DGI Node Active",
      "auth_sig": "Digital Signature: ",
      "proto_ready": "System Ready",
      "syncing": "Synchronization...",
      "unified_space": "Unified Fiscal Space",
      "secure_gateway": "Institutional gateway for Algerian tax obligations management.",
      "dgi_apps": "Declare your G50, IBS and TAP in one click.",
      "open_portal": "Access DGI Portal",
      "sync_progress": "Syncing data",
      "verify_obligations": "Verify Obligations",
      "gateway": "DGI Gateway",
      "master_server": "Sovereign Node",
      "compliance_deadlines": "Fiscal Compliance Calendar",
      "fiscal_year": "Fiscal Year",
      "action_required": "Action Required",
      "file_closed": "Compliant",
      "pending": "Pending",
      "decl_g50": "G50 Declaration",
      "acompte_prov": "IBS Provisional Installment",
      "opening_doc": "Opening DGI documentation...",
      "dgi_doc": "Official DGI Guide",
      "connecting_expert": "Connecting with a tax advisor...",
      "direct_support": "Institutional Support"
    },
    "advisor": {
      "engine": "Advisor Engine",
      "fin_decision": " Financial Decision Hub",
      "premium_hub": "Sovereign advisory system active",
      "sync_real": "Sync with Real Data",
      "sim_inputs": "Simulation Input parameters",
      "op_params": "Operational Parameters",
      "monthly_rev": "Monthly Revenue (DA)",
      "avail_liquidity": "Available Cash / Liquidity (DA)",
      "fixed_costs": "Monthly Fixed Costs (DA)",
      "var_costs": "Monthly Variable Costs (DA)",
      "debt_service": "Monthly Debt Service (DA)",
      "tax_prov": "Tax Provisions (DA)",
      "expected_inflows": "Expected Inflows (30 Days)",
      "upcoming_payments": "Upcoming Payments (30 Days)",
      "inv_context": "Investment Context",
      "capex": "Project Capex / Cost (DA)",
      "expected_roi": "Expected ROI (%)",
      "risk_profile": "Risk Profile Requirement",
      "analyze_data": "Analyze Financial Parameters",
      "launch_ai": "Launch AI Simulation",
      "est_time": "Estimated execution time: ",
      "results_intelligence": "Simulation Results & Financial Intelligence",
      "sim_pending": "Simulation Pending",
      "config_params": "Configure your operational and investment parameters above then launch the AI engine.",
      "ai_verdict": "AI Simulation Verdict",
      "optimal": "OPTIMAL",
      "prudence": "PRUDENCE",
      "critical": "CRITICAL",
      "health_score": "Financial Health Score",
      "proj_roi": "Project Expected ROI",
      "cash_pos": "Post-Inv Cash Position",
      "save": "Save Decision in Secure Vault",
      "key_indicators": "Key Operational Indicators",
      "revenue": "Monthly Revenue",
      "monthly": "Monthly",
      "rev_flow": "Monthly average operational revenue",
      "margin": "Margin",
      "net_op_perf": "Net operational margin before debt and taxes",
      "unlimited": "Unlimited",
      "proj_fin_autonomy": "Projected financial autonomy in months",
      "dscr_ratio": "DSCR Ratio",
      "debt_cov_cap": "Debt service coverage capacity",
      "proj_balance": "Projected Cash Balance (30 Days)",
      "current_treasury": "Current Treasury",
      "net_flow_30": "Expected Net Inflows (30 Days)",
      "debt_serv": "Debt Service repayment",
      "net_position": "Projected Net Position",
      "rational_analysis": "AI Rational Analysis",
      "internal_health": "Internal Health Diagnostics",
      "growth_potential": "Investment Logic & Growth",
      "sec_mitigation": "Security & Risk Mitigation",
      "strat_directives": "Strategic Directives",
      "impact": " Impact",
      "action_lever": "Execute action lever",
      "risk_control": "Risk Control & Alerts",
      "secure_perimeter": "Secure Perimeter",
      "no_crit_alert": "No critical risk detected in current simulation.",
      "decision_archive": "Decision Archives (Session)",
      "empty_log": "No decisions logged in current session."
    },
    "reports": {
      "title": "Financial Reports",
      "desc": "Generate and analyze your balance sheets, income statements and tax packages.",
      "back": "Back to Finance Console",
      "detailed_mode": "Detailed Mode",
      "activated": "ACTIVATED",
      "synthetic": "SYNTHETIC",
      "processing": "Processing...",
      "start_analysis": "Start Report Analysis",
      "hide_options": "Hide Advanced Options",
      "adv_options": "Show Advanced Options",
      "dgi_audit": "DGI Pre-Audit Compliance Check",
      "include_drafts": "Include Drafts and Temporary Postings"
    },
    "alertes": {
      "major": "Major Alert",
      "optimization": "Optimization Alert",
      "tax": "Tax Compliance",
      "cash_flow": "Cash Flow & Liquidity",
      "cost": "Cost Control",
      "performance": "Operational Performance",
      "score": "Global Risk Score",
      "unified_risk_index": "Unified Risk & Exposure Index",
      "severity_alert": "Severity Alert Active",
      "high_vigilance": "High Vigilance Required",
      "sys_stability": "Optimal System Stability",
      "financial_exposure": "Estimated Financial Exposure (DA)",
      "live_risk_engine": "Live Risk Scanning Engine",
      "audit_proto": "Audit protocol: ",
      "active": "ACTIVE",
      "last_scan": "Last scan: ",
      "selected_alert": "Alert selected",
      "selected_alerts": "Alerts selected",
      "bulk_processing": "BULK ACTION CONTROLLER",
      "deselect_all": "Deselect All",
      "resolve": "Resolve Selected",
      "ignore": "Ignore Selected",
      "analyze": "Deep Analyze",
      "access": "Access Target Module",
      "threat_feed": "Threat & Risk Intelligence Feed",
      "search_ph": "Filter active alerts by threat level, category...",
      "select_all": "Select All Alerts",
      "urgent": "Urgent Remediation Required",
      "normal_opt": "Normal Optimization Advisory",
      "no_signal": "No active alerts match the filters",
      "regulation": "Regulation Context",
      "risk_severity": "Risk Severity & Impact Rating",
      "systemic_diag": "Systemic Diagnosis",
      "risk_drivers": "Risk Drivers & Root Causes",
      "board_rec": "Board Recommendations",
      "priority_opt": "Priority Optimization",
      "audit_trail": "Audit Trail & Verification Logs",
      "pending_cfo": "Remediation pending CFO approval",
      "no_remediation": "No remediation action has been taken yet.",
      "synth_grouped": "Synthesis Action Board",
      "dynamic_audit": "Dynamic audit of ",
      "vigilance_points": " points of vigilance",
      "exit_mode": "Exit Multi-Select",
      "cum_impact": "Cumulative Financial Impact (DA)",
      "avg_gravity": "Average Gravity Rating",
      "synth_rec": "Synthetic Advisory Recommendations",
      "resolve_all": "Resolve All Selected Alerts",
      "context_nav": "Open Context Module",
      "pending_risk_analysis": "Select an active alert to view deep details.",
      "identify_threat": "Identify threats and optimize compliance.",
      "balance_solidity": "Balance Sheet Solidity",
      "tax_burden": "Tax Burden Index",
      "op_leverage": "Operating Leverage",
      "integrated_sys": "Risk scanning fully integrated with DGI nodes.",
      "expert_help": "Need expert legal advice?"
    },
    "evaluation": {
      "pot_score": "Market Potential Score",
      "risk_control_lbl": "Risk Level & Control",
      "stars": "STARS",
      "stable": "STABLE",
      "growth": "HIGH GROWTH",
      "at_risk": "AT RISK",
      "project_eval": "Evaluation Project ",
      "sys_selection": "Decision Support Engine",
      "reset": "Reset Simulation",
      "project_params": "Operational Project Parameters",
      "define_context": "Define the core dimensions of your business project for AI evaluation.",
      "eval_name": "Evaluation Name",
      "ex_project": "e.g. Fintech Platform launch",
      "sector": "Activity Sector",
      "maturity_stage": "Maturity Stage",
      "eval_profile": "Evaluation Profile",
      "launch_eval": "Launch Evaluation",
      "update_analysis": "Update Analysis",
      "team": "Team & Execution Capability",
      "market_pot": "Market Potential & Demand",
      "bus_model": "Business Model & Unit Economics",
      "innovation": "Innovation & Tech Moat",
      "feasibility": "Financial & Ops Feasibility",
      "risk": "Risk & Compliance Perimeter",
      "analysis_verdict": "AI Evaluation Verdict",
      "strat_interp": "Strategic interpretation of your project indicators.",
      "share_committee": "Share with Committee",
      "score_lbl": "Global Score: ",
      "strengths": "Key Systemic Strengths",
      "no_crit_strength": "No critical strength outstanding. Work on optimization.",
      "risk_zones": "Key Exposure & Risk Zones",
      "risks_controlled": "All risks appear properly controlled in this simulation.",
      "rec_action_plan": "Recommended Action Plan",
      "no_corr_measures": "No corrective measures generated yet.",
      "perf_score": "Operational Performance Score",
      "radar_profile": "Radar Maturity Profile",
      "maturity_pillar": "Maturity Pillars Distribution",
      "decision_center": "Action & Decision Center",
      "compare": "Compare Simulations",
      "excel": "Export Simulation Excel",
      "distribute_com": "Distribute to Investment Committee",
      "session_ranking": "Session Evaluations (",
      "report_dist": "Institutional Distribution"
    }
  },
  "kpis_datas": {
    "current_rev_desc": "Total turnover generated during the current fiscal year.",
    "prev_rev_desc": "Total turnover generated during the previous fiscal year.",
    "tot_costs": "Total Operating Costs",
    "tot_costs_desc": "Sum of fixed and variable operational costs during the period.",
    "active": "Active",
    "curr_assets_desc": "Liquid assets or resources that can be converted into cash within 12 months.",
    "curr_liab": "Current Liabilities",
    "curr_liab_desc": "Short-term financial obligations due within 12 months.",
    "fin_audit": "Financial Performance Audit",
    "perf_params": "Analyze your balance sheet ratios, margins and capital structure in real time.",
    "engine": "KPI Engine",
    "fin_data": "Financial Ratios Input Parameters",
    "quick_synth": "Real-Time Ratios Synthesis",
    "est_gross_margin": "Estimated Gross Margin",
    "growth_ratio": "Growth Ratio",
    "run_audit": "Run Ratios Analysis Audit",
    "sys_ready": "Performance calculation system ready."
  },
  "partners_page": {
    "pending": "Pending",
    "institutional_network": "Institutional Partner Network",
    "our_partners": "Official Partners",
    "partners_desc": "Connect and collaborate with certified institutions and professional networks.",
    "admin_mode_active": "Administrator Mode Active",
    "admin_sim": "Simulation Admin Console",
    "pending_apps": "Pending Partner Applications",
    "validation_req": "Verify credentials and approve network integration requests.",
    "validate": "Approve Application",
    "verified": "Verified",
    "consult": "Consult Profile",
    "dossier": "Dossier",
    "become_partner": "Join the Ecosystem",
    "apply_network": "Apply to Network",
    "apply": "Submit Application",
    "form_name": "Full Name",
    "function_title": "Function / Title",
    "organization": "Organization / Company",
    "form_email": "Professional Email Address",
    "desc_expertise": "Expertise & Collaboration Scope",
    "proof_doc": "Proof of Credentials / Corporate Document",
    "click_upload": "Click to upload PDF, PNG, or JPG document",
    "send_application": "Send Partner Application",
    "contact": "Contact",
    "active_partner": "Active Network Partner",
    "join_date": "Join Date",
    "intervention_domains": "Domains of Intervention & Expertise",
    "secure_doc": "Secure Documentation",
    "download": "Download File",
    "inst_level": "Institutional Level Integration",
    "validated_exp": "Validated Expert Networks",
    "national_cov": "National Operational Coverage"
  },
  "pricing": {
    "title": "Clear & Sovereign Pricing",
    "subtitle": "No hidden fees. Premium SaaS modules, advisory support, and institutional packages tailored for the Algerian entrepreneurial ecosystem.",
    "monthly": "Monthly Billing",
    "yearly": "Annual Billing (Save 15%)",
    "recommended": "Recommended",
    "freemium_title": "Sovereign Pricing Model",
    "freemium_desc": "Charikaty operates on a hybrid freemium and modular subscription system, combined with expert advisory and dedicated institutional offerings.",
    "philosophy": {
      "saas": {
        "title": "SaaS Subscriptions",
        "desc": "Access premium digital tools, automated compliance, and real-time dashboard analytics."
      },
      "advisory": {
        "title": "Institutional Advisory",
        "desc": "On-demand legal, financial, and tax experts ready to audit and guide your structure."
      },
      "partnerships": {
        "title": "Ecosystem Partners",
        "desc": "Special packages for incubators, accelerators, and technology parks."
      }
    },
    "plans": {
      "free": {
        "name": "Free",
        "price": "0",
        "period": "DZD/Month",
        "desc": "Perfect for students, idea validation, and early entrepreneurs.",
        "button": "Start Free Trial",
        "features": [
          "Basic Dashboard Access",
          "1 Active Project",
          "Community Support",
          "Limited AI Queries",
          "Sovereign Core OS access"
        ]
      },
      "starter": {
        "name": "Starter",
        "price": "1,500",
        "price_year": "15,000",
        "period": "DZD/Month",
        "desc": "For freelancers, auto-entrepreneurs, and early-stage projects.",
        "button": "Select Starter",
        "features": [
          "Advanced Dashboard",
          "3 Active Projects",
          "Standard Document Templates",
          "AI Co-pilot Lite",
          "Email Support",
          "Financial Analytics Basic"
        ]
      },
      "pro": {
        "name": "Pro",
        "price": "4,500",
        "price_year": "45,000",
        "period": "DZD/Month",
        "desc": "Ideal for fast-scaling startups and growing digital SMEs.",
        "button": "Select Pro",
        "features": [
          "Unlimited Active Projects",
          "Advanced AI Co-pilot Engine",
          "Full Legal & Tax Genvest modules",
          "Pre-Audit Compliance Checks",
          "24/7 Priority Support",
          "API Integration (Beta)"
        ]
      },
      "business": {
        "name": "Business",
        "price": "9,000",
        "price_year": "90,000",
        "period": "DZD/Month",
        "desc": "For established structures requiring advanced analytics and workspaces.",
        "button": "Select Business",
        "features": [
          "Everything in Pro",
          "Multi-user Workspace",
          "Advanced Financial Reports",
          "Dedicated Investor Dashboard",
          "Accounting System Exports",
          "Priority API access"
        ]
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "Custom",
        "period": "Quote on Request",
        "desc": "For groups, incubators, universities, and public institutions.",
        "button": "Contact Sales",
        "features": [
          "Guichet Unique direct node connection",
          "E-Taxes full synchronization",
          "On-premise deployment options",
          "Dedicated account manager & SLA",
          "Custom development & Integrations",
          "Training & onboarding sessions"
        ]
      }
    },
    "consulting": {
      "title": "Institutional On-Demand Consulting",
      "subtitle": "Get direct support from Algeria's leading corporate experts.",
      "legal": {
        "title": "Legal Consulting",
        "desc": "Corporate law, custom statutes drafting, bylaws and board organization.",
        "price": "15,000 DA",
        "duration": "1-3 days"
      },
      "finance": {
        "title": "Financial Consulting",
        "desc": "Cash-flow structuring, custom financial models, CAPEX planning.",
        "price": "20,000 DA",
        "duration": "2-4 days"
      },
      "tax": {
        "title": "Tax Consulting",
        "desc": "IBS, TAP optimization, VAT declaration guidance and pre-audit.",
        "price": "18,000 DA",
        "duration": "1-2 days"
      },
      "strategy": {
        "title": "Business Strategy",
        "desc": "Algerian market entry, scaling directives and operational guidelines.",
        "price": "30,000 DA",
        "duration": "1 week"
      },
      "request": "Request Consultation"
    },
    "services": {
      "investment": {
        "title": "GENVEST Investment Services",
        "desc": "Charikaty acts as a strategic interface for startup financing, business-angel networking, and sovereign capital matchmaking. We provide legal security and audit-grade performance verification for your investment pitches."
      },
      "government": {
        "title": "Public & Government Digitalization",
        "desc": "We build dedicated API connectors for public administrations, universities, and regional agencies to facilitate commercial register creation, CNAS declarations, and e-governement interoperability."
      }
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "q1": "How does the subscription work?",
      "a1": "You can select monthly or annual billing. All plans can be upgraded or downgraded instantly from your dashboard settings.",
      "q2": "Are my tax filings legally compliant?",
      "a2": "Yes. Our E-Taxes integration guidelines conform strictly to the Algerian General Tax Code and DGI requirements.",
      "q3": "Can I cancel at any time?",
      "a3": "Absolutely. You can terminate your subscription at the end of the current billing cycle with no penalty fee.",
      "q4": "What payment methods are supported?",
      "a4": "We support CIB, BaridiMob, and standard bank transfers. Corporate invoices are provided automatically."
    },
    "compare_features": "Compare All Features",
    "feature": "Feature",
    "free": "Free",
    "starter": "Starter",
    "pro": "Pro",
    "business": "Business",
    "enterprise": "Enterprise",
    "payment": {
      "title": "Accepted Payment Methods",
      "cib": "CIB Card",
      "baridi": "BaridiMob",
      "transfer": "Bank Transfer"
    },
    "cta": {
      "title": "Ready to digitalize your company?",
      "subtitle": "Join thousands of Algerian entrepreneurs using Charikaty to run their businesses.",
      "start": "Get Started Now",
      "demo": "Book a Demo",
      "contact": "Contact Our Team"
    }
  }
}
